import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ShopPage from "./pages/ShopPage";
import RecoveryGuidePage from "./pages/RecoveryGuidePage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import DisclaimerPage from "./pages/DisclaimerPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import RefundPage from "./pages/RefundPage";
import ShippingPage from "./pages/ShippingPage";
import AboutPage from "./pages/AboutPage";
import PeptideDetailPage from "./pages/PeptideDetailPage";
import PillarPage from "./pages/PillarPage";
import PartnersPage from "./pages/PartnersPage";
import CompliancePage from "./pages/CompliancePage";
import ProviderAccessPage from "./pages/ProviderAccessPage";
import TopicalsPage from "./pages/TopicalsPage";
import AffiliateProgramPage from "./pages/AffiliateProgramPage";
import SiteMapPage from "./pages/SiteMapPage";
import StateLocationPage from "./pages/StateLocationPage";
import StatesIndexPage from "./pages/StatesIndexPage";
import BusinessPage from "./pages/BusinessPage";
import EditorialStandardsPage from "./pages/EditorialPolicyPage";
import PressPage from "./pages/PressPage";
import GlossaryIndexPage from "./pages/GlossaryIndexPage";
import StateRegulatoryCheckerPage from "./pages/StateRegulatoryCheckerPage";
import AgeGate from "./components/AgeGate";

// SEO pillar/category routes (handled by single PillarPage component)
const PILLAR_ROUTES = [
  "peptides-for-med-spas",
  "anti-aging-peptides",
  "weight-loss-peptides",
  "recovery-peptides",
  "hormone-peptides",
  "sexual-wellness-peptides",
  "peptide-glossary",
];

// B2B business-audience routes (handled by single BusinessPage component)
const BUSINESS_ROUTES = [
  "for-med-spas",
  "wholesale-peptides-for-clinics",
  "peptide-protocols-for-aesthetic-practices",
  "for-providers",
];

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AgeGate />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/recovery-guide" element={<RecoveryGuidePage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/disclaimer" element={<DisclaimerPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/refund" element={<RefundPage />} />
          <Route path="/shipping" element={<ShippingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/peptides/:slug" element={<PeptideDetailPage />} />
          <Route path="/partners" element={<PartnersPage />} />
          <Route path="/compliance" element={<CompliancePage />} />
          <Route path="/provider-access" element={<ProviderAccessPage />} />
          <Route path="/topical-peptides" element={<TopicalsPage />} />
          <Route path="/affiliate-program" element={<AffiliateProgramPage />} />
          <Route path="/sitemap" element={<SiteMapPage />} />
          <Route path="/editorial-standards" element={<EditorialStandardsPage />} />
          <Route path="/press" element={<PressPage />} />
          <Route path="/glossary" element={<GlossaryIndexPage />} />
          <Route path="/tools/state-regulatory-checker" element={<StateRegulatoryCheckerPage />} />
          <Route path="/locations" element={<StatesIndexPage />} />
          <Route path="/locations/:state" element={<StateLocationPage />} />
          {PILLAR_ROUTES.map((slug) => (
            <Route key={slug} path={`/${slug}`} element={<PillarPage />} />
          ))}
          {BUSINESS_ROUTES.map((slug) => (
            <Route key={slug} path={`/${slug}`} element={<BusinessPage />} />
          ))}
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
